/**
 * Hero picker — four hero treatments with a switch to compare them.
 *
 * The homepage renders this instead of a hero directly. The choice is the
 * visitor's, kept in localStorage and settable by `?hero=` for sharing a
 * particular one; there is no server-side default beyond the first entry, so
 * the original cinematic hero is what a first-time visitor sees.
 */

import React, { /* useCallback, */ useEffect, useState } from 'react';
import ElfHero from './ElfHero';
import ElfHeroPosters from './ElfHeroPosters';
import ElfHeroPass from './ElfHeroPass';
import ElfHeroVinyl from './ElfHeroVinyl';
import './elf-hero-variants.css';

interface Variant {
  id: string;
  label: string;
  hint: string;
  Component: React.FC;
}

const VARIANTS: Variant[] = [
  { id: 'cinematic', label: 'Cinematic', hint: 'The film still, mascot reveal and word rotator', Component: ElfHero },
  { id: 'vinyl', label: 'Vinyl', hint: 'A record you can spin — the services are its tracks', Component: ElfHeroVinyl },
  { id: 'pass', label: 'Pass', hint: 'A festival laminate on a lanyard; turn it over', Component: ElfHeroPass },
  { id: 'posters', label: 'Paste-up', hint: 'A flyposted wall; the top sheet peels to the next', Component: ElfHeroPosters },
];

const STORE_KEY = 'elf.hero.v1';

/** URL wins (a shared link), then the last choice, then the original hero. */
function initialIndex(): number {
  try {
    const wanted = new URLSearchParams(window.location.search).get('hero');
    const fromUrl = VARIANTS.findIndex((v) => v.id === wanted || String(VARIANTS.indexOf(v) + 1) === wanted);
    if (wanted && fromUrl >= 0) return fromUrl;
    const saved = window.localStorage.getItem(STORE_KEY);
    const fromStore = VARIANTS.findIndex((v) => v.id === saved);
    if (fromStore >= 0) return fromStore;
  } catch {
    // Private windows and blocked site data — fall through to the default.
  }
  return 0;
}

export const ElfHeroPicker: React.FC = () => {
  // Switcher hidden for now — restore `setAt` along with it below.
  const [at /* , setAt */] = useState(initialIndex);

  useEffect(() => {
    try {
      window.localStorage.setItem(STORE_KEY, VARIANTS[at].id);
    } catch {
      // Not being able to remember the choice is not worth breaking the page for.
    }
  }, [at]);

  // const pick = useCallback((i: number) => {
  //   setAt(i);
  //   window.scrollTo({ top: 0, behavior: 'smooth' });
  // }, []);

  const { Component } = VARIANTS[at];

  return (
    <>
      <Component key={VARIANTS[at].id} />
      {/* Hero style switcher — hidden for now.
      <div className="elf-hswitch" role="group" aria-label="Hero style">
        <span className="elf-hswitch__label">Hero</span>
        {VARIANTS.map((v, i) => (
          <button
            key={v.id}
            type="button"
            className="elf-hswitch__btn"
            aria-pressed={i === at}
            title={v.hint}
            onClick={() => pick(i)}
          >
            <b>{i + 1}</b>
            {v.label}
          </button>
        ))}
      </div>
      */}
    </>
  );
};

export default ElfHeroPicker;
